import { Dialog, Toast } from "antd-mobile";
import Decimal from "decimal.js";
import copyString from 'clipboard-copy';
import dayjs from "dayjs"

// package.json has
// const HOST = 'http://api.oxyzcoin.cc/';
// const HOST = 'https://api.978osc.xyz/';
// 'https://sys.bitosc.top/'
const HOST = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8090/' : 'https://sys.enxbit.com/'

// # 判断是不是 ios 系统
export const IOSVersion = () => {
    var userAgent = navigator.userAgent;
    var version = 0;
    // # 正则表达式匹配iOS版本号
    var versionMatch = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (versionMatch && versionMatch.length > 1) {
      version = parseFloat(versionMatch[1] + '.' + versionMatch[2] + (versionMatch[3] ? '.' + versionMatch[3] : ''));
    }
    return version;
}

export const AndroidVersion = () => {
    const userAgent = navigator.userAgent;
    const match = userAgent.match(/Android\s([0-9\\.]*)/);
    return match ? parseFloat(match[1]) : 0;
}

export const FullURL = (path) => {
    if(typeof path === 'string') {
        return HOST + path;
    }
    return '';
}

export const ValidEmail = (email) => {
    if(email === undefined) {
        return false
    }
    const emailRegex = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/;
    return emailRegex.test(email);
}

export const ConvertToRate = (item, length = 2) => {
    if(item === undefined) {
        return '0.00'
    }
    return ((item.close / item.open - 1) * 100).toFixed(length);
}

// # 精度长度保留
export const DecimalConvert = (value, min = 2, max = 8) => {
    try {
        const decimalValue = new Decimal(value || '0.00')
        const length = decimalValue.decimalPlaces()
        if(length < min) {
            return decimalValue.toFixed(min)
        }
        else if(length > max) {
            return decimalValue.toFixed(max)
        }
        return decimalValue.toString()
    } catch {
        return '0.00'
    }
}

export const DecimalZero = () => {
    return new Decimal('0')
}

export const BigDecimalZero = (value) => {
    try {
        return  new Decimal(value || '0')
    } catch {
        return new Decimal('0')
    }
}

export const DecimalComparedToZero = (value) => {
    return BigDecimalZero(value).comparedTo(DecimalZero())
}

export const CopyToClipboard = (value) => {
    try {
        // # 删除全局拦截复制内容
        if(window.ig) {
            delete window.ig
        }
        copyString(value)
        ToastContent('Copy success')
    } catch {
        ToastContent('Copy Fail')
    }
}

export const AnyToStr = (value) => {
    if (value === null || value === undefined) {
      return String(value);
    }
    return value.toString();
}

export const ToastLoading = (content = 'Loading') => {
    Toast.show({
        content : content,
        icon : 'loading',
        duration : 0,
        maskClickable : false
    })
}

export const ToastContent = (content = 'Content') => {
    Toast.show({
        content : content
    })
}

export const ToastClear = () => {
    Toast.clear();
}

export const AlertContent = (content = 'content') => {
    Dialog.alert({
        content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>{content}</div>,
        closeOnMaskClick: true,
        confirmText : 'OK'
    })
}

export const AlertContentAction = (content = 'content', action = () => {}) => {
    console.log('=====');
    Dialog.alert({
        content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>{content}</div>,
        closeOnMaskClick: false,
        confirmText : 'OK',
        onConfirm : action
    })
}

const parseDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    return dayjs(date).format(format)
}

export const ToDate = (str, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (str == null) {
        return null
    }
    const value = '0' + str - 0
    return parseDate(new Date(value), format)
}

export const ToDate1 = (str) => {
    return ToDate(str, 'YYYY-MM-DD HH:mm')
}

export const ToDate2 = (str) => {
    return ToDate(str, 'YYYY/MM/DD')
}

export const ToDate3 = (str) => {
    return ToDate(str, 'HH:mm:ss')
}

export const ToDate4 = (str) => {
    return ToDate(str, 'HH:mm:ss YYYY-MM-DD')
}

export const ToDate5 = (str) => {
    return ToDate(str, 'HH:mm YYYY-MM-DD')
}

export const TradeLightColor = (val) => {
    if(DecimalComparedToZero(val) >= 0) {
        return '#08BF89'
    }
    return '#D92727'
}

export const TradeLightValueColor = (val1, val2) => {
    return val1 === val2 ? '#08BF89' : '#D92727'
}

